import { Injectable, Inject, InjectionToken, Type } from '@angular/core';
import { LogLevel } from './log-level';
import { Log } from './log';
import { Publisher } from './publisher';
import { LoggerConfig } from './logger-config';

export const LOGGER_CONFIG_TOKEN = new InjectionToken<LoggerConfig>('LoggerConfig');

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  readonly level: LogLevel;
  readonly publishersType: Type<Publisher>[];
  readonly publishers: Map<string, Publisher>;

  constructor(@Inject(LOGGER_CONFIG_TOKEN) config: LoggerConfig) {
    this.level = config.logLevel;
    this.publishersType = config.publishers;
    this.publishers = new Map<string, Publisher>();
  }

  addPublisher(publisherType: Type<Publisher>) {
    this.publishersType.push(publisherType);
  }

  isLevelValid(floor: LogLevel, requestedLevel: LogLevel): boolean {
    return (floor.level <= requestedLevel.level);
  }

  log(logLevel: LogLevel, msg, error = null) {
    if (!this.isLevelValid(this.level, logLevel)) {
      return;
    }

    const log = new Log(logLevel, msg, error);
    this.publishersType.forEach(type => {
      this.getPublisher(type).publish(log);
    });
  }

  error(msg, error = null) {
    this.log(LogLevel.ERROR, msg, error);
  }

  warning(msg, error = null) {
    this.log(LogLevel.WARNING, msg, error);
  }

  info(msg, error = null) {
    this.log(LogLevel.INFO, msg, error);
  }

  debug(msg, error = null) {
    this.log(LogLevel.DEBUG, msg, error);
  }

  getPublisher(publisherType: Type<Publisher>) {
    let publisher = this.publishers.get(publisherType.name);
    if (!publisher) {
      publisher = new publisherType();
      this.publishers.set(publisherType.name, publisher);
    }
    return publisher;
  }
}
